<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <!-- DAÑOS MATERIALES? -->
        <div v-if="isFieldVisible('material_damage')" class="col-md-3 mt-3">
          <label for="material_damage" class="form-label text-left">{{ getFieldDescription('material_damage') }}</label>
          <SelectTrueFalse
            class="form-control select-custom"
            :material_damage="formData.material_damage === 1"
            v-bind:data="selectedMaterialDamage" 
            v-on:update:data="selectedMaterialDamage = $event"
            @change="emitFieldChanged('material_damage')"
            required="required"
            maxlength="4"
          ></SelectTrueFalse>
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
      </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import SelectTrueFalse from './selectDatos/SelectTrueFalse';

export default {
  name: 'FormMaterialDamage',
  props: {
    data: Object,
  },
  components: {
    SelectTrueFalse,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const selectedMaterialDamage = ref(false);
    const showComponentData = ref(false);

    const formData = ref({
      material_damage: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (dataCompany.value && dataCompany.value.material_damage);
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      formData.value.material_damage = selectedMaterialDamage.value ? 1 : 0;
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
      selectedMaterialDamage,
      showComponentData
    };
  },
};
</script>
 
